import React, { Component } from 'react'
import Helmet from 'react-helmet'
import GitHubButton from 'react-github-btn'
import { graphql, Link } from 'gatsby'
import Layout from '../layout'
import PostListing from '../components/PostListing'
import ProjectListing from '../components/ProjectListing'
import SimpleListing from '../components/SimpleListing'
import SEO from '../components/SEO'
import config from '../../data/SiteConfig'
import projects from '../../data/projects'
import speaking from '../../data/speaking'
import podcasts from '../../data/podcasts'
import quotes from '../../data/quotes'
// import tania from '../../src/images/logo-white.png'
import tania from '../../content/images/1024-rou.png'

export default class Index extends Component {

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }

  render() {
    const { data } = this.props

    const latestPostEdges = data.latest.edges
    const popularPostEdges = data.popular.edges

    return (
      <Layout>
        <Helmet title={`Become a frontend, backend, fullstack software engineer | ${config.siteTitle}`} />
        <SEO />
        <div className="container">
          <div className="lead">
            <div className="elevator">
              <h1>{`SESV tutorial`}</h1>
              <p>
                Your learning and referencing resource to become a solid fullstack software engineer using <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noopener noreferrer">
                  JavaScript
                </a>, brought to you by a group of software engineers from <a href="https://en.wikipedia.org/wiki/Silicon_Valley" target="_blank" rel="noopener noreferrer">Sillicon Valley</a>.
                
              </p>
              <div class="g-ytsubscribe" data-channelid="UCLJBgRSh_7tXIrIkQQsxyUQ" data-layout="default" data-count="default"></div>
              <div className="social-buttons">
                {/* <a
                  className="patreon"
                  href="https://www.patreon.com/sesvtutorial"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Patreon
                </a> */}
                <GitHubButton
                  href="https://github.com/sesv-tutorial"
                  data-size="large"
                  data-show-count="true"
                >
                  sesv-tutorial
                </GitHubButton>
              </div>
            </div>
            <div className="newsletter-section">
              <img src={tania} className="newsletter-avatar" alt="SESV" />
              <div>
                <h3>Email Newsletter</h3>
                <p>
                  Get an update when new tutorial comes out by signing up below!
                </p>
                <a className="button" href="/contact/">
                  Subscribe
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container front-page">
          <section className="section">
            <h2>
              Latest Tutorials
              <Link to="/tutorials" className="view-all">
                View all
              </Link>
            </h2>
            <PostListing simple postEdges={latestPostEdges} />
          </section>

          <section className="section">
            <h2>
              Most Popular
              <Link to="/categories/popular" className="view-all">
                View all
              </Link>
            </h2>
            <PostListing simple postEdges={popularPostEdges} />
          </section>

          <section className="section">
            <h2>{`What people says about SESV tutorial`}</h2>
            <div className="quotations">
              {quotes.map(quote => (
                <blockquote className="quotation" key={quote.name}>
                  <p>{quote.quote}</p>
                  <cite>— {quote.name}</cite>
                </blockquote>
              ))}
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    latest: allMarkdownRemark(
      limit: 6
      sort: { fields: [fields___date], order: DESC }
      filter: { frontmatter: { template: { eq: "post" } } }
    ) {
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            categories
            thumbnail {
              childImageSharp {
                fixed(width: 150, height: 150) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
            date
            template
          }
        }
      }
    }
    popular: allMarkdownRemark(
      limit: 7
      sort: { fields: [fields___date], order: DESC }
      filter: { frontmatter: { categories: { eq: "Popular" } } }
    ) {
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            categories
            thumbnail {
              childImageSharp {
                fixed(width: 150, height: 150) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
            date
            template
          }
        }
      }
    }
  }
`
